import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SubMenu, SubMenuWrapper } from '../../ui';
import { useFeatures } from '../settings/hooks';

const Exports = () => {

  const { t } = useTranslation();

  const features = useFeatures();
  const [navigationItems, setNavigationItems] = useState([])


  useEffect(() => {
    const items = [
      { label: t('export.courseExport'), 'value': 'course' },
      { label: t('export.userExport'), 'value': 'user' },
      { label: t('export.groupExport'), 'value': 'group' },
      features.salesExport && { label: t('globals.sales'), 'value': 'sales' }
    ].filter(Boolean)
    setNavigationItems(items)

  }, [features.salesExport, t])

  return (
    <>
      <SubMenuWrapper>
        {!!navigationItems.length && <SubMenu navigationItems={navigationItems} pathnameSplitIndex={2} />}
      </SubMenuWrapper>
      <Outlet />
    </>
  );
};

export default Exports;
